import { Button, Container, Grid, Typography, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useAppStateContext } from '../../../AppStateProvider/AppStateProvider';

const MainContainer = styled('div')({
  display: 'block',
});

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: '1.5em',
  borderRadius: '8px',
  width: '337px',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

const Header = styled(Grid)(({ theme }) => ({
  float: 'left',
  [theme.breakpoints.down('md')]: {
    float: 'initial',
  },
}));

const OkButton = styled(Grid)(({ theme }) => ({
  clear: 'left',
  [theme.breakpoints.down('md')]: {
    clear: 'initial',
    marginBottom: '2em',
  },
}));

const PaperContainer = styled(Grid)(({ theme }) => ({
  float: 'right',
  marginRight: '1em',
  [theme.breakpoints.down('md')]: {
    float: 'initial',
    display: 'flex',
    justifyContent: 'center',
    margin: '0 0 2.5em 0',
  },
}));

export function SupportedBrowser() {
  const { dispatch, userAgentInfo } = useAppStateContext();

  const browser = userAgentInfo.browser;
  const operatingSystem = userAgentInfo.os;

  return (
    <>
      <Container>
        <MainContainer>
          <Header item lg={5}>
            <Typography variant="h1" gutterBottom>
              Browser supported
            </Typography>
            <Typography variant="body1" gutterBottom>
              Looks like your browser is good to go. We're almost done!
            </Typography>
          </Header>

          <PaperContainer item lg={5}>
            <StyledPaper>
              <Typography variant="body1">
                <strong>Browser: </strong>
                {browser.name} {browser.version}
              </Typography>
              ​
              <Typography variant="body1">
                <strong>Operating System: </strong>
                {operatingSystem.name} {operatingSystem.version}
              </Typography>
            </StyledPaper>
          </PaperContainer>

          <OkButton item lg={5}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => dispatch({ type: 'next-pane' })}
              style={{ marginRight: '1.5em' }}
            >
              Ok
            </Button>
          </OkButton>
        </MainContainer>
      </Container>
    </>
  );
}
